import React from 'react'
import {BrowserRouter as Router, Switch, Route, withRouter} from 'react-router-dom'
import Banner from '../Components/Banner/Banner'
import BasicModal from '../Components/BasicModal/BasicModal'
import Peliculas from '../Components/Peliculas'
import Pelicula from '../Components/Peliculas/Pelicula/Pelicula'
import Reproductor from '../Components/Reproductor/Reproductor'
import ReproductorSerie from '../Components/Reproductor/ReproductorSerie'
import ReproductorVideo from '../Components/Reproductor/ReproductorVideo'
import Series from '../Components/Series'
import Serie from '../Components/Series/Serie/Serie'
import SliderBasic from '../Components/SliderBasic/SliderBasic'
import { useAuth } from '../context/authContext'
import Sliders from '../pages/Home/sliders/Sliders'
import Perfil from '../pages/Perfil/Perfil'

function Routers() {

    const {setShowModal,showModal,titleModal,contentModal} =useAuth()


    return (

       // <Provider store={store} >

       <>

            <Switch>
                <Route path="/profile" exact  >
                    <Perfil />
                </Route>
                <Route path="/" exact >
                    <Banner  />
                    <Sliders/>
                </Route>
                <Route path="/peliculas" >
                    <Peliculas  />
                </Route>
                <Route path="/pelicula/:id" >
                    <Pelicula  />
                </Route>
                <Route path="/play/:id" >
                    <Reproductor />
                </Route>
                <Route path="/player/:id" >
                    <ReproductorVideo  />
                </Route>
                <Route path="/playser/:uuidPoster/:title/:temporada/:episodio" >
                    <ReproductorSerie  />
                </Route>
                <Route path="/series" >
                    <Series  />
                </Route>
                <Route path="/serie/:id" >
                    <Serie />
                </Route>
            </Switch>
                <BasicModal  show={showModal} setShow={setShowModal} title={titleModal} >
                        {contentModal}
                </BasicModal>
       </>


       // </Provider>
        
    )
}

export default withRouter(Routers)